import { ExternalLink } from 'lucide-react';
import { approvalItemUrl } from '../itemRouting';
import type { ApprovalRequest } from '../types';

export default function ApprovalObjectLink({
  request,
}: {
  request: Pick<ApprovalRequest, 'object_type' | 'object_id'>;
}) {
  const href = approvalItemUrl(request.object_type, request.object_id);
  if (!href) return <span>Položka není dostupná.</span>;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1.5 text-primary-600 underline underline-offset-2 hover:text-primary-700"
      aria-label="Otevřít položku v nové kartě"
    >
      Otevřít položku
      <ExternalLink className="h-4 w-4" aria-hidden="true" />
    </a>
  );
}
